import { render, staticRenderFns } from "./TypeMoldForm.vue?vue&type=template&id=e9bbd6e4&"
import script from "./TypeMoldForm.vue?vue&type=script&lang=js&"
export * from "./TypeMoldForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports